export enum ReasonForStay {
  bachelorBachelorette = 'BACHELOR/BACHELORETTE',
  birthday = 'BIRTHDAY',
  citySports = 'CITY/SPORTS',
  corporateRetreatWork = 'CORPORATE_RETREAT/WORK',
  couplesGetaway = 'COUPLES_GETAWAY',
  familyVacation = 'FAMILY_VACATION',
  privateEvent = 'PRIVATE_EVENT',
  tripWithFriends = 'TRIP_WITH_FRIENDS',
  other = 'OTHER',
  wedding = 'WEDDING',
}

export const reasonForStayLabel = {
  [ReasonForStay.bachelorBachelorette]: 'Bachelor/Bachelorette',
  [ReasonForStay.birthday]: 'Birthday',
  [ReasonForStay.citySports]: 'City Sports',
  [ReasonForStay.corporateRetreatWork]: 'Corporate Retreat/Work',
  [ReasonForStay.couplesGetaway]: 'Couples Getaway',
  [ReasonForStay.familyVacation]: 'Family Vacation',
  [ReasonForStay.privateEvent]: 'Private Event',
  [ReasonForStay.tripWithFriends]: 'Trip with friends',
  [ReasonForStay.other]: 'Other',
  [ReasonForStay.wedding]: 'Wedding',
}
